import React from "react";
import "./styles.scss";
import { filterTimeStamp } from "../../../../../api/helper";
import UserTag from "../../../shared/UserTag";
import Menu from "./Menu";

export default ({ post, postsDeleter }) => (
  <div className="post-header d-flex justify-content-between">
    <div className="d-flex align-items-center">
      <UserTag user={post.author} className="w-100" />
      <small className="text-default ml-2">
        {filterTimeStamp(post.created_at)}
      </small>
    </div>
    <Menu
      object={post}
      userId={post.author.id}
      type={post.type}
      objectDeleter={postsDeleter}
    />
  </div>
);
